<template>
  <v-container fluid pa-0>
    <v-row dense>
      <v-col cols="auto">
        <i>{{ activityLogEntry.timestampString }}</i>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <span>{{ activityLogEntry.entityType }}</span>
      </v-col>
    </v-row>
    <v-row v-if="activityLogEntry.status" dense>
      <v-col cols="auto">
        <bm-chip
          small
          :colour="
            appStore.state.theme === 'dark'
              ? activityLogEntry.status.chipColourDark ??
                activityLogEntry.status.chipColour
              : activityLogEntry.status.chipColour
          "
          :text="activityLogEntry.status.translation"
        />
      </v-col>
    </v-row>
    <v-row v-if="activityLogEntry.association" dense>
      <v-col
        v-for="(heading, index) of activityLogEntry.association.textLines"
        :key="index + heading.value"
        cols="12"
      >
        <span v-if="heading.name" class="font-weight-bold">
          {{ heading.name }}:
        </span>
        <span>{{ heading.value }}</span>
      </v-col>
      <v-col v-if="activityLogEntry.association.route" cols="12">
        {{ $m.tasks_associated_with }}
        <router-link
          :to="activityLogEntry.association.route"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ activityLogEntry.association.name }}
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import BmChip from "@/components/controls/BmChip.vue";
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ActivityLogEntryCardType } from "@/components/pages/outlet/crm/subcomponents/activityLogEntryCard";
import { translate } from "@/plugins/i18n";
import appStore from "@/store/modules/appStore";

export default defineComponent({
  name: "ActivityLogEntryCard",
  components: { BmChip },
  props: {
    activityLogEntry: {
      type: Object as PropType<ActivityLogEntryCardType>,
      required: true,
    },
  },
  setup() {
    return { translate, appStore };
  },
});
</script>
